// LoadingIndicator.jsx
import React from 'react'

const SPROCKET_URL = 'https://cdn.shopify.com/s/files/1/0564/1820/5796/files/sprocket.svg?v=1717219866'

// Renders a sprocket div colored with any hex value via CSS mask-image.
// mask-image applies the SVG as an alpha mask and background-color fills it —
// no filter math needed, and the color is exactly the hex you pass in.
function Sprocket({ color, size, animationDelay = '0s', style = {} }) {
  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        maskImage: `url(${SPROCKET_URL})`,
        WebkitMaskImage: `url(${SPROCKET_URL})`,
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        animation: `spin 2s linear ${animationDelay} infinite`,
        ...style
      }}
    />
  )
}

function LoadingIndicator({ message = 'Loading...' }) {
  const sprocketColor = '#e98969'

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(145, 195, 222, 0.8)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Jost', sans-serif"
      }}>
      {/* Center sprocket */}
      <Sprocket color={sprocketColor} size="150px" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }} />

      <p
        style={{
          position: 'absolute',
          top: '38%',
          left: '50%',
          transform: 'translateX(-50%)',
          color: '#FFFFFF',
          fontSize: '24px',
          fontFamily: "'roc-grotesk-wide', sans-serif",
          margin: 0,
          fontWeight: 700,
          whiteSpace: 'nowrap'
        }}>
        {message}
      </p>

      {/* Decorative background sprockets */}
      {[0, 1, 2].map((index) => (
        <Sprocket
          key={index}
          color={sprocketColor}
          size={`${40 + index * 20}px`}
          animationDelay={`${index * 0.45}s`}
          style={{
            position: 'absolute',
            top: `${8 + index * 6}%`,
            left: `${8 + index * 28}%`
          }}
        />
      ))}

      <style>{`
        @keyframes spin {
          0%   { transform: rotate(0deg) }
          100% { transform: rotate(360deg) }
        }
      `}</style>
    </div>
  )
}

export default LoadingIndicator
